<template>
  <div>
    <!-- 添加菜单 -->
<!--    <el-button type="primary" @click="add()" class="add">增加栏目</el-button>-->
    <!-- 菜单列表 -->
    <ul>
      <li>
        <el-row class='dark'>
          <el-col :span="2">菜单等级</el-col>
          <el-col :span="3">菜单名称</el-col>
          <el-col :span="11">菜单简介</el-col>
          <el-col :span="2">pc端显示</el-col>
          <el-col :span="2">移动端显示</el-col>
          <el-col :span="4">操作</el-col>
        </el-row>
      </li>
      <li v-for="item in list" :key="item.id">
        <el-row>
          <el-col :span="2">
            <el-tag @click="showmen(item.id)"><i
              :class="!item.sebshow?'el-icon-caret-right':'el-icon-caret-bottom'" v-if="item.hasOwnProperty('children')"></i><i v-else>&emsp;</i>一级菜单
            </el-tag>
          </el-col>
          <el-col :span="3">{{item.name}}</el-col>
          <el-col :span="11">{{item.intro.length == 0?'无':item.intro}}</el-col>
          <el-col :span="2">
            <el-switch
              v-model="item.pc"
              disabled>
            </el-switch>
          </el-col>
          <el-col :span="2">
            <el-switch
              v-model="item.move"
              disabled>
            </el-switch>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" icon="el-icon-edit" circle @click="handleEdit(item)"></el-button>
<!--            <el-button type="danger" icon="el-icon-delete" circle @click="handleDelete(item.id)"></el-button>-->
          </el-col>
        </el-row>
        <ul v-show="item.sebshow">
          <li v-for="items in item.children" :key="items.id">
            <el-row>
              <el-col :span="2">
                <el-tag @click="showmen(items.id)" type="success"><i
                  :class="!items.sebshow?'el-icon-caret-right':'el-icon-caret-bottom'"
                  v-if="items.hasOwnProperty('children')"></i><i v-else>&emsp;</i>二级菜单
                </el-tag>
              </el-col>
              <el-col :span="3">{{items.name}}</el-col>
              <el-col :span="11">{{items.intro.length == 0?'无':items.intro}}</el-col>
              <el-col :span="2">
                <el-switch
                  v-model="items.pc"
                  disabled>
                </el-switch>
              </el-col>
              <el-col :span="2">
                <el-switch
                  v-model="items.move"
                  disabled>
                </el-switch>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" icon="el-icon-edit" circle @click="handleEdit(items)"></el-button>
<!--                <el-button type="danger" icon="el-icon-delete" circle @click="handleDelete(items.id)"></el-button>-->
              </el-col>
            </el-row>
            <ul v-show="items.sebshow">
              <li v-for="itemss in items.children" :key="itemss.id">
                <el-row>
                  <el-col :span="2">
                    <el-tag type="info">&emsp;三级菜单</el-tag>
                  </el-col>
                  <el-col :span="3">{{itemss.name}}</el-col>
                  <el-col :span="11">{{itemss.intro.length == 0?'无':itemss.intro}}</el-col>
                  <el-col :span="2">
                    <el-switch
                      v-model="itemss.pc"
                      disabled>
                    </el-switch>
                  </el-col>
                  <el-col :span="2">
                    <el-switch
                      v-model="itemss.move"
                      disabled>
                    </el-switch>
                  </el-col>
                  <el-col :span="4">
                    <el-button type="primary" icon="el-icon-edit" circle @click="handleEdit(itemss)"></el-button>
<!--                    <el-button type="danger" icon="el-icon-delete" circle @click="handleDelete(itemss.id)"></el-button>-->
                  </el-col>
                </el-row>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <!-- 菜单详情 -->
    <el-dialog title="编辑菜单" :visible.sync="dialogVisible" width="55%" @closed="closed()">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="菜单等级" class="formib">
          <el-select
            v-model="form.grade"
            placeholder="请选择菜单等级"
            @change="onSelectedDrug(form.grade)"
          >
            <el-option v-for="item in onemenu" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="父级菜单" v-if="form.grade != 1 && form.grade != ''" class="formib">
          <el-select v-model="form.managemenu" placeholder="请选择">
            <el-option v-for="item in formmenu" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="简介">
          <vue-ueditor-wrap v-model="form.intro"></vue-ueditor-wrap>
        </el-form-item>
        <el-form-item label="PC显示" class="formib">
          <el-switch v-model="form.pcmenu"></el-switch>
        </el-form-item>
        <el-form-item label="PC显示位置" v-if="form.pcmenu" class="formib">
          <el-input-number v-model="form.pcmenusite" :min="2" :max="menusite.pcmenusite" label="描述文字"></el-input-number>
        </el-form-item><br>
        <el-form-item label="手机显示" class='formib'>
          <el-switch v-model="form.movemenu"></el-switch>
        </el-form-item>
        <el-form-item label="手机显示位置" v-if="form.movemenu" class="formib">
          <el-input-number v-model="form.movemenusite" :min="2" :max="menusite.movemenusite" label="描述文字"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        list: [
          {
                id: 3,
                name: '网站建设',
                grade: 2,
                intro: '针对性网站优化网站建设',
                pc: true,
                move: false,
                sebshow: false,
                children: [
                  {
                    id: 111,
                    name: '高端网站定制',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  },
                  {
                    id: 112,
                    name: '手机网站开发',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  },
                  {
                    id: 113,
                    name: '大数据可视化设计开发',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  },
                  {
                    id: 114,
                    name: '网站运营服务',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  }
                ]
              },
          {
                id: 12,
                name: '微信应用',
                grade: 2,
                intro: '微信应用开发网络运营',
                pc: true,
                move: false,
                sebshow: false,
                children: [
                  {
                    id: 121,
                    name: '微信公众号开发',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  },
                  {
                    id: 122,
                    name: '微信小程序开发',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  },
                  {
                    id: 123,
                    name: '微信公众号运营',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  },
                  {
                    id: 124,
                    name: '微信营销类功能开发',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  }
                ]
              },
          {
                id: 13,
                name: '软件开发',
                grade: 2,
                intro: 'IOS、Android研究开发',
                pc: true,
                move: false,
                sebshow: false,
                children: [
                  {
                    id: 131,
                    name: '软件定制开发',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  },
                  {
                    id: 132,
                    name: '智慧体育管理系统',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  },
                  {
                    id: 133,
                    name: '环保巡检管理系统',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  },
                  {
                    id: 134,
                    name: '应急管理危化品追溯系统',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  }
                ]
              },
          {
                id: 14,
                name: '品牌设计',
                grade: 2,
                intro: '根据客户所在行业设计品牌',
                pc: true,
                move: false,
                sebshow: false,
                children: [
                  {
                    id: 111,
                    name: 'VI识别系统设计',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  },
                  {
                    id: 112,
                    name: 'Logo设计',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  },
                  {
                    id: 113,
                    name: '平面设计',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  },
                  {
                    id: 114,
                    name: '品牌定位',
                    grade: 3,
                    intro: '',
                    pc: false,
                    move: false
                  }
                ]
              },
          {
            id: 2,
            name: '经典案例',
            grade: 1,
            intro: '互联网高端定制，设计，开发，一站式网站运营',
            pc: true,
            move: true,
            sebshow: false,
            children: [
              {
                id: 21,
                name: '网站',
                grade: 2,
                intro: '',
                pc: false,
                move: false
              },
              {
                id: 22,
                name: '微信公众号',
                grade: 3,
                intro: '',
                pc: false,
                move: false
              },
              {
                id: 23,
                name: '微信小程序',
                grade: 2,
                intro: '',
                pc: false,
                move: false
              },
              {
                id: 24,
                name: '软件系统',
                grade: 2,
                intro: '',
                pc: false,
                move: false
              }
            ]
          },
          {
            id: 3,
            name: '飞天动态',
            grade: 1,
            intro: '为客户提供具有价值的互联网服务',
            pc: false,
            move: false,
            sebshow: false,
            // children: [
            //   {
            //     id: 31,
            //     name: '飞天观点',
            //     grade: 2,
            //     intro: '',
            //     pc: false,
            //     move: false,
            //     sebshow: false
            //   },
            //   {
            //     id: 32,
            //     name: '知识扩展',
            //     grade: 2,
            //     intro: '',
            //     pc: false,
            //     move: false,
            //     sebshow: false
            //   }
            // ]
          }
        ],
        menu: [
          {id: 1, title: "我们的服务", grade: "1"},
          {id: 11, title: "网站建设", grade: "2"},
          {id: 12, title: "微信营销", grade: "2"},
          {id: 13, title: "软件开发", grade: "2"},
          {id: 14, title: "品牌设计", grade: "2"},
          {id: 15, title: "智慧云飞天", grade: "2"},
          {id: 2, title: "飞天动态", grade: "1"},
          {id: 16, title: "飞天观点", grade: "2"},
          {id: 17, title: "知识拓展", grade: "2"},
          {id: 3, title: "成功案例", grade: "1"}
        ],
        formmenu: [],
        dialogVisible: false,
        form: {
          grade: 1,
          title: "",
          intro: "",
          pcmenu: false,
          pcmenusite: '',
          movemenu: true,
          movemenusite: '',
          managemenu: ''
        },
        newmenu: "",
        onemenu: [
          {id: 1, title: '一级菜单'},
          {id: 2, title: '二级菜单'},
          {id: 3, title: '三级菜单'}
        ],
        menusite: {
          pcmenusite: 7,
          movemenusite: 4
        }
      };
    },
    mounted() {
      var asd = []
      function qq(ss) {
        ss.map(item => {
          var qwe = {
            id: item.id,
            name: item.name,
            grade: item.grade
          }
          asd.push(qwe)
          if (item.hasOwnProperty('children')) {
            qq(item.children)
          }
        })
      }
      qq(this.list)
      this.menu = asd
    },
    methods: {
      // 编辑菜单
      handleEdit(edit) {
        console.log(edit)
        this.form.grade = edit.grade;
        this.dialogVisible = true;
        this.menusite.pcmenusite = 2;
        this.menusite.movemenusite = 1;
        this.menusites(this.list)
        this.onSelectedDrug(edit.grade)
        console.log(this.menusite.pcmenusite)
        console.log(this.menusite.movemenusite)
      },
      //删除菜单
      handleDelete(a, b) {
      },
      //增加菜单
      // add() {
      //   this.menusite.pcmenusite = 2;
      //   this.menusite.movemenusite = 1;
      //   this.menusites(this.list)
      //   this.onSelectedDrug(1);
      //   this.form.grade = "";
      //   this.form.title = "";
      //   this.form.intro = "";
      //   this.form.pcmenu = false;
      //   this.form.movemenu = false;
      //   this.form.managemenu = [];
      //   this.dialogVisible = true;
      // },
      // 删除菜单依赖
      close(item) {
        this.form.managemenu.splice(this.form.managemenu.indexOf(item), 1);
      },
      onSelectedDrug(gad) {
        this.formmenu = []
        this.menu.map(item => {
            if (item.grade == (gad - 1)) {
              this.formmenu.push(item)
            }
          }
        )

      },
      closed() {
        this.newmenu = "";
      },
      showmen(val) {
        this.list.map(item => {
          if (item.id == val) {
            item.sebshow = item.sebshow == false ? true : false;
          }
          if (item.hasOwnProperty('children')) {
            item.children.map(item => {
              if (item.id == val) {
                item.sebshow = item.sebshow == false ? true : false;
              }
            })
          }
        })
      },
      menusites(sss){
        sss.map(item => {
          if(item.pc){
            this.menusite.pcmenusite++
          }
          if(item.move){
            this.menusite.movemenusite++
          }
          if (item.hasOwnProperty('children')) {
            this.menusites(item.children)
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .dark {
    background: #f5f7fa;
    min-height: 50px;
    font-weight: bold;
  }

  .el-row {
    color: #909399;

    .el-col {
      line-height: 50px;
      box-sizing: border-box;
      padding-left: 10px;
      border: 1px solid #ebeef5;
      margin-top: -1px;
    }
  }

  .el-form-item {
    label {
      width: 200px !important;
    }

    > div {
      margin-left: 200px !important;
    }
  }

  .tag {
    padding: 15px 0px;

    > span {
      margin-right: 15px;
      margin-top: 15px;
    }
  }

  .add {
    margin-bottom: 20px;
  }

  .formib {
    display: inline-block;
    line-height: 36px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/menu.vue